export default function formatCurrency(value: number) {
  const ret = new Number(Math.round(value * 100) / 100).toFixed(2)
  return ret.replace('.', ',') + ' €'
}
